module.exports = __webpack_public_path__ + "static/media/045.39c64e5c.jpg";